import { render, staticRenderFns } from "./NewSale.vue?vue&type=template&id=18799c81&scoped=true&"
import script from "./NewSale.vue?vue&type=script&lang=js&"
export * from "./NewSale.vue?vue&type=script&lang=js&"
import style0 from "./NewSale.vue?vue&type=style&index=0&id=18799c81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18799c81",
  null
  
)

export default component.exports